










import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AppStore = namespace("App");

@Component({})
export default class Loading extends Vue {
  @AppStore.Getter("isLoading") isLoading!: boolean;

  public size = "15px";
}
